import { render, staticRenderFns } from "./LoadingNotification.vue?vue&type=template&id=efec3e62&scoped=true&"
import script from "./LoadingNotification.vue?vue&type=script&lang=js&"
export * from "./LoadingNotification.vue?vue&type=script&lang=js&"
import style0 from "./LoadingNotification.vue?vue&type=style&index=0&id=efec3e62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efec3e62",
  null
  
)

export default component.exports